import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Close1"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_1428_20539)"><rect width="16" height="16" fill="#F2F3F7"></rect><path d="M12.3854 2.93978C12.1991 2.75347 11.897 2.75347 11.7107 2.93978L7.9998 6.65067L4.28894 2.9398C4.10262 2.75348 3.80055 2.75348 3.61424 2.9398L2.93954 3.6145C2.75323 3.80081 2.75323 4.10289 2.93954 4.2892L6.6504 8.00007L2.93958 11.7109C2.75327 11.8972 2.75327 12.1993 2.93958 12.3856L3.61428 13.0603C3.80059 13.2466 4.10267 13.2466 4.28898 13.0603L7.9998 9.34947L11.7106 13.0603C11.8969 13.2466 12.199 13.2466 12.3853 13.0603L13.06 12.3856C13.2463 12.1993 13.2463 11.8972 13.06 11.7109L9.3492 8.00007L13.0601 4.28919C13.2464 4.10287 13.2464 3.8008 13.0601 3.61449L12.3854 2.93978Z" fill="#737E99"></path></g><defs><clipPath id="clip0_1428_20539"><rect width="16" height="16" fill="white"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var close1 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { close1 as default };
